import { inputBaseClasses, styled } from '@mui/material';
import { DateRangePicker } from '@mui/x-date-pickers-pro';

export const DateRangePickerStyled = styled(DateRangePicker)(({ theme }) => ({
  display: 'flex',

  [`& .${inputBaseClasses.root}`]: {
    backgroundColor: theme.palette.common.white,
  },
}));
